(() => {
 const init = () => {
  const details = document.getElementById('DutMobilePerks');
  if (!details || details.dataset.ready) return;
  details.dataset.ready = 'true';
  const summary = details.querySelector('summary');
  const content = details.querySelector('.dut-perks__scroll');
 const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
 let motion;
 let closing = false;
 const slide = (opening, done) => {
  motion?.cancel();
  if (reducedMotion.matches) { content.style.overflow = ''; done?.(); return; }
  const height = content.getBoundingClientRect().height;
  content.style.overflow = 'hidden';
  const collapsed = { height: '0px' };
  const expanded = { height: `${height}px` };
  motion = content.animate(opening ? [collapsed, expanded] : [expanded, collapsed], {
   duration: 360, easing: 'cubic-bezier(.22,.61,.36,1)'
  });
  motion.onfinish = () => { motion = null; content.style.overflow = ''; done?.(); };
 };
 const close = (focus = false) => {
  if (!details.open || closing) return;
  closing = true;
  slide(false, () => { details.open = false; closing = false; if (focus) summary.focus(); });
 };
 summary.addEventListener('click', event => {
  if (details.open) { event.preventDefault(); close(); }
 });
  const measure = () => details.style.setProperty('--dut-perks-top', `${Math.max(0, summary.getBoundingClientRect().bottom)}px`);
  details.addEventListener('toggle', () => { measure(); if (details.open && !closing) slide(true); });
  window.addEventListener('resize', () => { measure(); if (innerWidth >= 990) close(); });
  details.querySelectorAll('.dut-perks__close, .dut-perks__collapse, .dut-perks__backdrop').forEach(button => button.addEventListener('click', () => close(true)));
  details.addEventListener('keydown', event => { if (event.key === 'Escape') { event.stopPropagation(); close(true); } });
  details.querySelector('.dut-header-chat').addEventListener('click', () => close());
  document.addEventListener('click', event => { if (details.open && !details.contains(event.target)) close(); });
  document.addEventListener('focusin', event => { if (details.open && !details.contains(event.target)) close(); });
  if (details.querySelector('[data-perks-feedback]') && location.hash === '#DutPerksNewsletter') details.open = true;
 };
 init(); document.addEventListener('shopify:section:load', init);
})();
